import { MarginsResponse } from "../../../../api/useGetMargins";
import {
  Data,
  formatPercent,
  getCurrencyValue,
} from "../../../CallAlertsAuxWindow/auxUtils";

export const buildBuyingPower = (
  marginSummaryData: MarginsResponse
): Data[] => {
  // Mappings preserve namings from Ascend where possble.
  const {
    dayTradeBuyingPower: dayTradeBuyingPowerIssued,
    marginEquityPercent,
    overnightBuyingPower: overnightBuyingPowerIssued,
    sma,
    committedSma: smaCommitted,
    cashExcessEquity,
    marginConcentrationExcess: marginExcessEquityWithConcentration,
    cashAvailableToWithdraw: availableToWithdraw,
    marginExcess: marginExcessEquity,
    totalConcentrationExcess,
    unsettledCash,
  } = marginSummaryData;

  return [
    {
      label: "Margin Excess",
      value: getCurrencyValue(marginExcessEquity),
      isNumeric: true,
    },
    {
      label: "Cash Excess Equity",
      value: getCurrencyValue(cashExcessEquity),
      isNumeric: true,
    },
    {
      label: "Margin Concentrated Excess",
      value: getCurrencyValue(marginExcessEquityWithConcentration),
      isNumeric: true,
    },
    // Margin Excess Equity NYSE field removed (FEECM-17670 Req 9)
    {
      label: "Total Concentrated Excess",
      value: getCurrencyValue(totalConcentrationExcess),
      isNumeric: true,
    },
    {
      label: "Unsettled Cash",
      value: getCurrencyValue(unsettledCash),
      isNumeric: true,
    },
    {
      label: "Overnight Buying Power",
      value: getCurrencyValue(overnightBuyingPowerIssued),
      isNumeric: true,
    },
    {
      label: "IMBP", // Updated abbreviation (FEECM-17670 Req 8)
      value: getCurrencyValue(dayTradeBuyingPowerIssued),
      isNumeric: true,
    },
    {
      label: "Available to Withdraw",
      value: getCurrencyValue(availableToWithdraw),
      isNumeric: true,
    },
    {
      label: "SMA",
      value: getCurrencyValue(sma),
      isNumeric: true,
    },
    {
      label: "Committed SMA",
      value: getCurrencyValue(smaCommitted),
      isNumeric: true,
    },
    {
      label: "Margin Equity Percent",
      value: formatPercent(marginEquityPercent),
      isNumeric: true,
    },
  ];
};
